import { useEffect, useState } from "react";
import axios from "axios";

const DynamicImageOrPDFShow = ({url, divStyle={}, iframeStyle={}, imgStyle={}, divClassName="", iframeClassName="", imagClassName=""}) => {

  const [fileUrl, setFileUrl] = useState(url);
  const [isPdf, setIsPdf] = useState(false);

  useEffect(()=>{

    setFileUrl(url);
  },[url])

  useEffect(() => {
    const fetchFileType = async () => {
      try {
        const response = await axios({
          method: "get",
          url: url,
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });;

        debugger
        const contentType = response.headers.get("Content-Type");

        if (contentType) {
          if (contentType.includes("pdf")) {
            setIsPdf(true);
          } else if (contentType.includes("image")) {
            setIsPdf(false);
          }
        //   setFileUrl("http://localhost:5001/api/ItemMaster/GetImage?D1ItemId=360");
        }
      } catch (error) {
        console.error("Error fetching file type:", error);
      }
    };

    fetchFileType();
  }, [url]);

  return (
    <div style={divStyle} className={divClassName}>
      {fileUrl && (
        isPdf ? (
          <iframe
            src={fileUrl}
            style={iframeStyle}
            className={iframeClassName}
            title="Prescription PDF"
          />
        ) : (
          <img
            className={imagClassName}
            style={imgStyle}
            src={fileUrl}
            alt="My Prescription"
          />
        )
      )}
    </div>
  );
};

export default DynamicImageOrPDFShow;
